export default __webpack_public_path__ + "static/media/Avatar-17.8852f51f.png";